// extracted by mini-css-extract-plugin
module.exports = {"adjustPosition":"layout-module--adjustPosition--3nihE"};